export const normalValues = {
  seminalFluidAnalysis: {
    appearance: 'Grey Opalescent',
    liquefactionTime: '<60 mins',
    viscosity: 'G1-3',
    volume: '>1.5 ml',
    ph: '7.2-7.8',
    agglutination: 'Nil',
    roundCellCount: '',
  },
  spermAnalysis: {
    spermCount: '>16 M/ml',
    totalCount: '39 M/Ejaculate',
    motility: '>42%',
    progression: '>30%',
    nonProgression: '',
    immotile: '',
    viability: '>54%',
    morphologyNormal: '>4%',
    morphologyAbnormal: '',
  },
  dnaFregmentationIndex: '15-25% MODERATE DNA INTEGRITY, >25% HIGH DFI',
};
